__turbopack_context__.v({
  "sidebar-navigation__content": "sidebar-navigation-component-module-scss-module__4SD0ha__sidebar-navigation__content",
  "sidebar-navigation__content--open": "sidebar-navigation-component-module-scss-module__4SD0ha__sidebar-navigation__content--open",
  "sidebar-navigation__headline": "sidebar-navigation-component-module-scss-module__4SD0ha__sidebar-navigation__headline",
  "sidebar-navigation__toggle": "sidebar-navigation-component-module-scss-module__4SD0ha__sidebar-navigation__toggle",
});
